import LinkButton from '../../global/components/LinkButton';

export default function DetailsPage() {
  return (
    <div className="pt-2 flex flex-col justify-center items-center">
        <div className="my-44">
            <p>Coming soon!</p>
            <LinkButton to='/services' className="mx-5">
                Go Back
            </LinkButton>
        </div>
    </div>
  )
}
